// Import Vue
import Vue from 'vue';

// Import Framework7
import Framework7 from 'framework7/framework7-lite.esm.bundle.js';

// Import Framework7-Vue Plugin
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js';

// Import Framework7 Styles
import 'framework7/css/framework7.bundle.css';

// Import Icons and App Custom Styles
import '../css/icons.css';
import '../css/app.scss';

// Import App Component
import App from '../components/app.vue';

// Init Framework7-Vue Plugin
Framework7.use(Framework7Vue);


// Init App
new Vue({
  el: '#app',
  render: (h) => h(App),

  // Register App Component
  components: {
    app: App
  },
  data() {
    var user = JSON.parse(localStorage.getItem("user"))
      ? JSON.parse(localStorage.getItem("user"))
      : {
        name: "",
        email: "",
        phone: ""
      };
    return {
      user: user,
      respApi: "respApi",
      popupOpened: false,
      errorCarBrand: false,
      errorStateNumber: false,
      errorBodyType: false,
      selectCar: 0,
      btn: {
        text: "Сохранить",
        isEnable: true
      },
      form: {
        data: [
          {
            type: "cars",
            id: "",
            attributes: {
              carBrand: "",
              stateNumber: "",
              category: 10,
              color: ""
            }
          }
        ]
      },
      categories: {
        data: [
          {
            type: "categories",
            id: "",
            attributes: {
              title: ""
            }
          }
        ]
      },
      garage: {
        data: [
          {
            type: "cars",
            id: "",
            attributes: {
              carBrand: "",
              stateNumber: "",
              category: "",
              color: ""
            }
          }
        ]
      },
      services: "",
      category: "",
      preloader: true,
      isServices: true,
      count: 0
    };

  },
  methods: {
    phoneFormat(phone) {
      phone = phone.toString().replace(
        /(8)?(\+7)?(\d{3})(\d{3})(\d{2})(\d{2})/,
        "+7 $3 $4-$5-$6"
      );
      return phone;
    },
    createPopup(carID) {
      this.errorCarBrand = false;
      this.errorStateNumber = false;
      this.errorBodyType = false;

      console.log("createPopup");
      this.popupOpened = true;

      // console.log(Number(carID));
      if (!isNaN(Number(carID))) {
        this.cars("", "GET", "cars/" + carID, ["form"]);
        this.btn = {
          text: "Сохранить",
          isEnable: true
        };
      } else {
        this.form = {
          data: [
            {
              type: "cars",
              id: "",
              attributes: {
                carBrand: "",
                stateNumber: "",
                category: "",
                color: ""
              }
            }
          ]
        };
        this.btn = {
          text: "Добавить",
          isEnable: false
        };
      }

      this.$f7ready(f7 => {
        // Call F7 APIs here
        let that = this;

        let getData = {
          filter: {
            group_id: 0,
          },
        };
        f7.request({
          url: "https://ms.bctip.ru/admin/api/typomojka/v1/categories",
          method: "GET",
          dataType: "json",
          data: getData,
          success: function (data, status) {
            if (data.data != null) {
              that.categories = data;
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            let data = JSON.parse(XMLHttpRequest.response);
            if (data.errors != null) {
              data.errors.forEach(function (error) {
                f7.dialog.alert(error.detail, "Ошибка " + error.status);
              });
            } else {
              f7.dialog.alert(errorThrown, "Ошибка " + textStatus);
            }
          },
          beforeSend: function (xhr, settings) {
            xhr.setRequestHeader(
              "authorization",
              "Bearer " + localStorage.getItem("token")
            );
          }, //set tokenString before send
        });
      });

    },
    checkForm(carID, action) {
      var errors = [];
      var formData = this.$f7.form.convertToData("#carData");
      // console.log(formData);
      // console.log(action);
      // console.log(Number(carID));

      if (formData.carBrand == "") {
        this.errorCarBrand = true;
        errors.push("errorCarBrand");
      }

      if (!this.validStateNumber(formData.stateNumber)) {
        this.errorStateNumber = true;
        errors.push("errorStateNumber");
      }

      if (formData.category == "") {
        this.errorBodyType = true;
        errors.push("errorBodyType");
      }

      if (!errors.length) {
        // this.cars("", "GET", "cars");
        if (action == "Сохранить") {
          var toast = this.$f7.toast.create({
            text: `${formData.carBrand} с госномером ${formData.stateNumber} отредактирована.`,
            closeTimeout: 5000
          });
          this.editStorage(carID, formData);
        } else {
          var toast = this.$f7.toast.create({
            text: `${formData.carBrand} с госномером ${formData.stateNumber} добавлена в гараж.`,
            closeTimeout: 5000
          });
          this.writeStorage(carID, formData);
        }
        toast.open();

        return;
        // console.log("this.$f7route.context.car.key");
        // console.log(this.$f7route.context.car.key);
        // if (this.$f7route.context.car.key == "-1") {
        //   console.log("Открыть прайс-лист.");
        //   this.$f7.views.main.router.navigate("/price/");
        // } else {

        //   this.$f7router.back("/profile/", { force: true });
        // }
      }
    },
    loadService() {
      var formData = this.$f7.form.convertToData("#serviceData");
      console.log("formData");
      console.log(formData);

      if (!this.$root.isServices) {
        return false;
      }

      if (formData.car == "") {
        formData.car = 0;
        formData.services = [];
        this.form = 0;
      }
      var order = {
        car: this.garage.data[formData.car],
        services: formData.services
      };
      console.log("order");
      console.log(order);
      this.category = this.garage.data[formData.car].attributes.category;
      // this.writeStorage(carID, order);
      this.getServices();
    },
    validStateNumber(stateNumber) {
      var re = /^[АВЕКМНОРСТУХ]?\d?\d\d\d[АВЕКМНОРСТУХ][АВЕКМНОРСТУХ]\d\d\d?$/;
      return re.exec(stateNumber);
    },
    writeStorage(carID, formData) {
      var car = {
        data: [
          {
            type: "cars",
            id: String(carID),
            attributes: {
              carBrand: formData.carBrand,
              stateNumber: formData.stateNumber,
              category: formData.category,
              color: formData.color
            }
          }
        ]
      };
      this.cars(car, "POST", "cars", ["garage"]);
      this.popupOpened = false;
    },
    editStorage(key, formData) {
      var car = {
        data: [
          {
            type: "cars",
            id: String(key),
            attributes: {
              carBrand: formData.carBrand,
              stateNumber: formData.stateNumber,
              category: formData.category,
              color: formData.color
            }
          }
        ]
      };
      // var cars = this.garage.data;
      // var i = 0;
      // cars.forEach((element) => {
      //   if (car.data[0].id == element.id) {
      //     this.garage.data[i].attributes.carBrand = car.data[0].attributes.carBrand;
      //     this.garage.data[i].attributes.stateNumber = car.data[0].attributes.stateNumber;
      //     this.garage.data[i].attributes.category = car.data[0].attributes.category;
      //     this.garage.data[i].attributes.color = car.data[0].attributes.color;
      //   }
      //   i++;
      // });
      this.cars(car, "PATCH", "cars/" + key, ["garage"]);
      this.popupOpened = false;
      // this.$f7.popup.close();
    },
    deleteCar(key) {
      // var key = this.$f7route.context.car.key;
      console.log(key);
      var toast = this.$f7.toast.create({
        text: `${this.form.data[0].attributes.carBrand} с госномером ${this.form.data[0].attributes.stateNumber} удалена.`,
        closeTimeout: 5000
      });
      toast.open();
      this.cars("", "DELETE", "cars/" + key);

      var cars = this.garage.data;
      var i = 0;
      cars.forEach((element) => {
        if (key == element.id) {
          this.garage.data.splice(i, 1);
        }
        i++;
      });
      this.popupOpened = false;
    },
    cars(cars, method, url = "cars", doit = []) {
      this.preloader = true;
      this.$f7ready(f7 => {
        let that = this;
        f7.request({
          url: "https://ms.bctip.ru/admin/api/typomojka/v1/" + url,
          method: method,
          dataType: "json",
          data: cars == "" ? "" : JSON.stringify(cars),
          success: function (data, status) {
            that.preloader = false;
            if (data.data != null) {
              if (data.data.length == 0 && method == "GET") {
                console.log("Нет машин в гараже.");
                if (doit.indexOf('popup') != -1) {
                  that.createPopup();
                }
                that.isServices = false;
                that.garage = [];
                that.selectCar = "add";
                return false;
              } else {
                that.isHaveCar = true;
                if (doit.indexOf('garage') != -1) {
                  if (data.data.length == 1) {
                    that.selectCar = 0;
                  }
                  that.garage = data;
                }
                if (doit.indexOf('form') != -1) {
                  console.log(data);
                  that.form = data;
                }
                if (doit.indexOf('service') != -1) {
                  that.loadService();
                }
              }
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            let data = JSON.parse(XMLHttpRequest.response);
            that.preloader = false;
            if (data.errors != null) {
              data.errors.forEach(function (error) {
                // f7.dialog.alert(error.detail, "Ошибка " + error.status);
                f7.dialog.alert(
                  error.detail,
                  "Ошибка " + error.status,
                  function () {
                    if (error.status == 403) {
                      localStorage.clear();
                      f7.views.main.router.navigate("/registration/");
                    }
                  }
                );
              });
            } else {
              f7.dialog.alert(errorThrown, "Ошибка " + textStatus);
            }
            return false;
          },
          beforeSend: function (xhr, settings) {
            xhr.setRequestHeader(
              "authorization",
              "Bearer " + localStorage.getItem("token")
            );
          } //set tokenString before send
        });
      });
    },
    getServices() {
      this.preloader = true;
      this.$f7ready(f7 => {
        let that = this;
        let getData = {
          filter: {
            category_id: that.category
          }
        };
        f7.request({
          url: "https://ms.bctip.ru/admin/api/typomojka/v1/services",
          method: "GET",
          dataType: "json",
          data: getData,
          success: function (data, status) {
            if (data.data != null) {
              that.services = data;
              that.preloader = false;
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            let data = JSON.parse(XMLHttpRequest.response);
            if (data.errors != null) {
              data.errors.forEach(function (error) {
                f7.dialog.alert(error.detail, "Ошибка " + error.status);
              });
            } else {
              f7.dialog.alert(errorThrown, "Ошибка " + textStatus);
            }
          },
          beforeSend: function (xhr, settings) {
            xhr.setRequestHeader(
              "authorization",
              "Bearer " + localStorage.getItem("token")
            );
          } //set tokenString before send
        });
      });
    },
  }
});
